import PropTypes from 'prop-types';
import React from 'react';

import MatchChange, {
  IMatchChangeHp,
  IMatchChangeLmp,
  MatchChangeVariant,
  MatchChangeVariantList,
} from '../../molecules/match-change/match-change';
import { IGliderComponent } from '../glider-wrapper/glider-wrapper';

/**
 * This component should manage ACTIVE/SELECTED item callback and DISABLED items
 * Should also expose a FRAGMENT with HMTL ELEMENTS to GLIDER
 * because REACT-GLIDER need a LIST of COMPONENTS not WRAPPED in a CONTAINER/DIV
 */
// Must extend IGliderComponent to be used inside new GliderWrapper
export interface IMatchChangeTable extends IGliderComponent<MatchChangeVariant> {
  isSSR?: boolean;
  matchList: Array<IMatchChangeLmp | IMatchChangeHp>;
}

const MatchChangeTable: React.FC<IMatchChangeTable> = ({
  isSSR = false,
  matchList = [],
  variant = 'lmp',
  activeSlideIndex,
  trackingData,
}) => {
  const matchChangeTable: Array<JSX.Element> = matchList.map(
    (args: IMatchChangeLmp | IMatchChangeHp, index: number) => (
      <MatchChange
        {...args}
        key={index}
        variant={variant}
        trackingData={trackingData}
        isSelected={index === activeSlideIndex}
      />
    )
  );

  // SSR = No GLIDER component but GLIDER WRAPPER for CSS
  return isSSR ? (
    <div className={`glider-wrapper glider-wrapper--${variant} glider-wrapper--ssr`}>
      <div className="glider-contain">
        <div className="glider-component glider">
          <div className="glider-track--custom glider-track">{matchChangeTable}</div>
        </div>
      </div>
    </div>
  ) : (
    <React.Fragment>{matchChangeTable}</React.Fragment>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  MatchChangeTable.propTypes = {
    activeSlideIndex: PropTypes.number, // From IGliderComponent
    matchList: PropTypes.arrayOf<IMatchChangeLmp | IMatchChangeHp>(PropTypes.exact(MatchChange.propTypes!).isRequired)
      .isRequired,
    variant: PropTypes.oneOf<MatchChangeVariant>(MatchChangeVariantList), // From IGliderComponent
  };
}

export default MatchChangeTable;
